import { createSignal } from '@verclam/pulsar';

/** `true` while a capture runs in this tab or in another one. */
const captureInProgressSignal = createSignal<boolean>(false);

export const setCaptureInProgress = (isInProgress: boolean): void => {
	captureInProgressSignal.value = isInProgress;
};

export default captureInProgressSignal;
